import Notify from "vue-notifyjs";
import SideBar from "@/components/SidebarPlugin";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import VueMoment from "vue-moment";
import filters from "../helpers/filters";
import "es6-promise/auto";

//css assets
// import "bootstrap/dist/css/bootstrap.css";
import "@/assets/sass/bootstrap/bootstrap.scss";
import "@/assets/sass/paper-dashboard.scss";

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Notify);
    Vue.use(VueMoment);
    Vue.use(filters);
  }
};
